// Sundries::Examples — curated placeholder values for Australian contexts.
//
// Why these specific values? Because placeholder text is interface copy, and
// interface copy shapes user expectations. "John Smith" tells your user that
// you built this product for a monocultural anglosphere. Australia isn't that.
//
// The 2021 Census tells us that Chinese and Indian ancestries are the fastest-
// growing in Australia, and Vietnamese Australians have been here since the
// 1970s. A South Asian first name paired with a Vietnamese surname is a quiet
// signal: this product was built for the country as it actually is.
//
// The address defaults to Marrickville (NSW 2204) — a suburb whose demographic
// mix genuinely reflects multicultural Sydney, and whose postcode is instantly
// recognisable to anyone who's lived in the Inner West. State-specific values
// are available for when you want to feel local.

import data from "../../../../lib/sundries/examples.json"

export const examples = data
export type Examples = typeof data
